import { z } from "zod";
/** Jam lokal "HH:mm" (00:00 sampai 23:59). */
export const timeString = z
    .string()
    .trim()
    .regex(/^([01][0-9]|2[0-3]):[0-5][0-9]$/, "Format jam harus HH:mm.");
/** Teks opsional: string kosong dinormalkan menjadi undefined. */
export function optionalText(max) {
    return z
        .string()
        .trim()
        .max(max)
        .optional()
        .transform((value) => (value === "" || value === undefined ? undefined : value));
}
/** Tautan opsional yang wajib diawali http:// atau https:// bila diisi. */
export const optionalUrl = z
    .string()
    .trim()
    .max(500)
    .refine((value) => value === "" || /^https?:[/][/][^ ]+$/.test(value), "Tautan harus diawali http:// atau https://")
    .optional()
    .transform((value) => (value === "" || value === undefined ? undefined : value));
/** Parameter paginasi standar. */
export const paginationSchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    perPage: z.coerce.number().int().min(1).max(100).default(20),
});
/** Body validasi kegiatan. */
export const validationRequestSchema = z
    .object({
    decision: z.enum(["APPROVED", "REJECTED"]),
    notes: optionalText(2000),
})
    .refine((value) => value.decision !== "REJECTED" || (value.notes ?? "").length >= 5, {
    message: "Alasan penolakan wajib diisi minimal 5 karakter.",
    path: ["notes"],
});
/**
 * Body aksi telaah (review): hanya catatan opsional.
 *
 * Sengaja dipisah dari validationRequestSchema: memanggil `.partial()` pada
 * skema yang mengandung refinement melempar galat saat runtime
 * (".partial() cannot be used on object schemas containing refinements").
 */
export const reviewRequestSchema = z.object({
    notes: optionalText(2000),
});
//# sourceMappingURL=common.js.map